var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('b-container',[_c('h1',{staticClass:"text-watermark"},[_vm._v("Vous n'avez aucune tâche")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }